<template>
  <custom-dialog class="reset-password-bd" :title="model.title" :visible="visible" v-on="$listeners" width="480px">
    <div class="dialog-body">
      <el-form :model="form" ref="form" :rules="rules" :validate-on-rule-change="false">
        <el-form-item prop="pwd">
          <el-input :type="inputType" v-model="form.pwd" :placeholder="$t('reset_pwd_dialog.qsrxmm')">
            <i class="icon icon-xianshi" style="font-size: 16px; margin-right: 8px" v-if="inputType === 'text'" @click="inputType = 'password'" slot="suffix"></i>
            <i class="icon icon-yincang" style="font-size: 16px; margin-right: 8px" v-if="inputType === 'password'" @click="inputType = 'text'" slot="suffix"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <p class="tip">{{ $t('reset_pwd_dialog.mmcdw816wbszfhzmrylz') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" :disabled="loading" @click="savePassword">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      inputType: 'password',
      loading: false,
      form: {
        pwd: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        pwd: [
          {
            required: true,
            min: 8,
            max: 16,
            message: this.$t('reset_pwd_dialog.mmcdw816wbszfhzmrylz'),
          },
          {
            validator: null,
            message: this.$t('reset_pwd_dialog.mmcdw816wbszfhzmrylz'),
          },
        ],
      };
    },
  },
  mounted() {
    this.rules.pwd[1].validator = (rule, value, callback) => {
      const reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;
      if (!reg.test(value.toString())) {
        callback(new Error());
      } else {
        callback();
      }
    };
  },
  methods: {
    // 重置密码
    savePassword: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(
          apis.ResetPwd,
          {
            userId: this.model.data,
            newPwd: this.encrypt(this.form.pwd),
          },
          true
        ).then(() => {
          this.visible = false;
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
        });
      });
    },
  },
};
</script>

<style lang="scss">
.reset-password-bd {
  .tip {
    line-height: 20px;
    padding-top: 10px;
    color: #b1b1b1;
    font-size: 12px;
    padding-left: 6px;
  }
}
</style>
